import styled from 'styled-components';

import { colors, fontWeights, fonts } from 'theme';

import { Button } from './Button';

export const TextButton = styled(Button)`
  padding: 0;
  background: none;
  border: 0;
  appearance: none;
  font-size: 14px;
  font-family: ${fonts.sans};
  letter-spacing: 0.44px;
  font-weight: ${fontWeights.semiBold};
  ${(props) => `
    color: ${props.reverse ? 'white' : colors.waterBlue};
  `}
  &[disabled] {
    color: ${colors.battleshipGrey};
    opacity: 0.5;
  }
  &:not([disabled]) {
    cursor: pointer;
    &:hover,
    &:focus {
      text-decoration: underline;
    }
  }
`;
